export enum ESocialMediaType {
  FACEBOOK = `facebook`,
  INSTAGRAM = `instagram`,
  YOUTUBE = `youtube`,
}

export enum EInputType {
  EMAIL = `email`,
  NUMBER = `number`,
  TEXT = `text`,
}
